import {
    CREATE_FALL_PROTECTION,
    CREATE_FALL_PROTECTION_REQUEST,
    CREATE_FALL_PROTECTION_FAIL,
    SUBMIT_FALL_PROTECTION,
    SUBMIT_FALL_PROTECTION_REQUEST,
    SUBMIT_FALL_PROTECTION_FAIL,
    UPDATE_FALL_PROTECTION,
    UPDATE_FALL_PROTECTION_REQUEST,
    UPDATE_FALL_PROTECTION_FAIL,
    SET_FALL_PROTECTION_DRAFT,
    SET_FALL_PROTECTION_DRAFT_REQUEST,
    SET_FALL_PROTECTION_DRAFT_FAIL,
    APPROVE_FALL_PROTECTION,
    APPROVE_FALL_PROTECTION_REQUEST,
    APPROVE_FALL_PROTECTION_FAIL,
    REJECT_FALL_PROTECTION,
    REJECT_FALL_PROTECTION_REQUEST,
    REJECT_FALL_PROTECTION_FAIL,
    GET_FALL_PROTECTION,
    GET_FALL_PROTECTION_REQUEST,
    GET_FALL_PROTECTION_FAIL,
    GET_FALL_PROTECTIONS,
    GET_FALL_PROTECTIONS_REQUEST,
    GET_FALL_PROTECTIONS_FAIL,
    GET_FALL_PROTECTIONS_BY_USER,
    GET_FALL_PROTECTIONS_BY_USER_REQUEST,
    GET_FALL_PROTECTIONS_BY_USER_FAIL,
    GET_FALL_PROTECTIONS_BY_LOCATION,
    GET_FALL_PROTECTIONS_BY_LOCATION_REQUEST,
    GET_FALL_PROTECTIONS_BY_LOCATION_FAIL,
    DELETE_FALL_PROTECTION,
    DELETE_FALL_PROTECTION_REQUEST,
    DELETE_FALL_PROTECTION_FAIL,

} from "../types/fallProtectionTypes"

const initState = {
    fallProtection: null,
    fallProtections: [],
    fallProtectionsByUser: [],
    error: null,
    loading: false,
  };

  const fallprotectionReducer = (state = initState, action) => {
    switch (action.type) {
        case CREATE_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CREATE_FALL_PROTECTION:
            return {
                ...state,
                fallProtection: action.payload.data,
                loading: false,
            };
        case CREATE_FALL_PROTECTION_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case UPDATE_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case UPDATE_FALL_PROTECTION:
            return {
                ...state,
                fallProtection: action.payload.data,
                loading: false
            }
        case UPDATE_FALL_PROTECTION_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case SET_FALL_PROTECTION_DRAFT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SET_FALL_PROTECTION_DRAFT:
            return {
                ...state,
                fallProtection: action.payload.data,
                loading: false
            }
        case SET_FALL_PROTECTION_DRAFT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case APPROVE_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case APPROVE_FALL_PROTECTION:
            return {
                ...state,
                fallProtection: action.payload.data,
                loading: false
            };
        case APPROVE_FALL_PROTECTION_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case REJECT_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REJECT_FALL_PROTECTION:
            return {
                ...state,
                fallProtection: action.payload.data,
                loading: false
            };
        case REJECT_FALL_PROTECTION_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };

        case SUBMIT_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case SUBMIT_FALL_PROTECTION: 
            return {
                ...state,
                fallProtection: action.payload.data,
                loading: false
            }
        case SUBMIT_FALL_PROTECTION_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        case GET_FALL_PROTECTIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_FALL_PROTECTIONS:
            return {
                ...state,
                loading: false,
                fallProtections: action.payload.data
            };
        case GET_FALL_PROTECTIONS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_FALL_PROTECTION:
            return {
                ...state,
                loading: false,
                fallProtection: action.payload.data,
            };
        case GET_FALL_PROTECTION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_FALL_PROTECTIONS_BY_USER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_FALL_PROTECTIONS_BY_USER:
            return {
                ...state,
                loading: false,
                fallProtectionsByUser: action.payload.data
            };
        case GET_FALL_PROTECTIONS_BY_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_FALL_PROTECTIONS_BY_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_FALL_PROTECTIONS_BY_LOCATION:
            return {
                ...state,
                loading: false,
                fallProtections: action.payload.data
            };
        case GET_FALL_PROTECTIONS_BY_LOCATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        
        case DELETE_FALL_PROTECTION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DELETE_FALL_PROTECTION:
            return {
                ...state,
                loading: false,
                fallProtection: action.payload,
            };
        case DELETE_FALL_PROTECTION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
    };

    export default fallprotectionReducer;

